import React from 'react';
import PropTypes from 'prop-types';
import Text from '../../Text';
class ExtraText extends React.PureComponent {
    render() {
        const { dataHook, text } = this.props;
        return (React.createElement(Text, { secondary: true, dataHook: dataHook }, text));
    }
}
ExtraText.propTypes = {
    dataHook: PropTypes.string,
    text: PropTypes.string.isRequired,
};
export default ExtraText;
//# sourceMappingURL=ExtraText.js.map